var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.538,
    height: 21.75,
    viewBox: "0 0 21.538 21.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-svgrepo-com",
    transform: "translate(-2 -1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M7,4.115V2.5",
    transform: "translate(0.385 0)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M17,4.115V2.5",
    transform: "translate(1.154 0)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-2276.077-123.615h-4.308c-4.055,0-6.091,0-7.353-1.262s-1.262-3.3-1.262-7.354v-2.154c0-.939,0-1.75.015-2.481h21.508c.015.731.015,1.542.015,2.481v2.154c0,4.056,0,6.092-1.261,7.354S-2272.021-123.615-2276.077-123.615Zm3.23-6.462a1.078,1.078,0,0,0-1.076,1.076,1.078,1.078,0,0,0,1.076,1.077,1.079,1.079,0,0,0,1.078-1.077A1.078,1.078,0,0,0-2272.846-130.077Zm-5.384,0a1.077,1.077,0,0,0-1.076,1.076,1.078,1.078,0,0,0,1.076,1.077,1.078,1.078,0,0,0,1.076-1.077A1.078,1.078,0,0,0-2278.23-130.077Zm-5.385,0a1.079,1.079,0,0,0-1.078,1.076,1.079,1.079,0,0,0,1.078,1.077,1.078,1.078,0,0,0,1.077-1.077A1.078,1.078,0,0,0-2283.615-130.077Zm10.769-4.308a1.078,1.078,0,0,0-1.076,1.077,1.078,1.078,0,0,0,1.076,1.076,1.078,1.078,0,0,0,1.078-1.076A1.079,1.079,0,0,0-2272.846-134.385Zm-5.384,0a1.078,1.078,0,0,0-1.076,1.077,1.077,1.077,0,0,0,1.076,1.076,1.078,1.078,0,0,0,1.076-1.076A1.078,1.078,0,0,0-2278.23-134.385Zm-5.385,0a1.079,1.079,0,0,0-1.078,1.077,1.079,1.079,0,0,0,1.078,1.076,1.078,1.078,0,0,0,1.077-1.076A1.078,1.078,0,0,0-2283.615-134.385Zm16.072-3.981h-21.376a4.947,4.947,0,0,1,1.181-3.372c1.262-1.262,3.3-1.262,7.353-1.262h4.308c4.056,0,6.092,0,7.354,1.262a4.947,4.947,0,0,1,1.18,3.371Z",
    transform: "translate(2291 147.115)",
    fill: "gray"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.591dcd912387a0d292b9aaa13809fd82.svg";
export { ForwardRef as ReactComponent };